import React from 'react';
import { formatValue } from '../../charts/chartUtils';

export function KpiHeroBlock({ data }) {
    const row = data?.rows?.[0];

    if (!row) {
        return <p className="no-data">Sin datos</p>;
    }

    const { metric, value, format, change, change_direction, change_sentiment } = row;

    // Determine sentiment: explicit > inferred from direction
    let sentiment = change_sentiment;
    if (!sentiment && change_direction) {
        sentiment = change_direction === 'up' ? 'positive' : 'negative';
    }

    const arrow = change_direction === 'up' ? '\u25B2' : change_direction === 'down' ? '\u25BC' : '';

    return (
        <div className="kpi-hero-block">
            <span className="kpi-hero-label">{metric}</span>
            <span className="kpi-hero-value">{formatValue(value, format)}</span>
            {change !== undefined && change !== null && (
                <span className={`kpi-hero-change kpi-hero-change--${sentiment || 'neutral'}`}>
                    {arrow} {Math.abs(change).toFixed(1)}%
                </span>
            )}
        </div>
    );
}
